export default __webpack_public_path__ + "static/media/Arrow.0920d4dc.svg";